import {
  getGetClientProfileQueryKey,
  useGetClientProfile,
} from '@biasafe.queries/clients-client-id-profile/clients-client-id-profile';
import { useState } from 'react';
import { useClientPhoto } from './activityFeed/useClientPhoto';
import type { ClientResponse } from '@biasafe.models';
import { cn } from '@/lib/utils';

export function DirectoryAvatar({
  client,
  shape = 'circle',
}: {
  client: ClientResponse;
  shape?: 'circle' | 'square';
}) {
  const { data: profile } = useGetClientProfile(client.id, {
    query: {
      queryKey: getGetClientProfileQueryKey(client.id),
      enabled: !client.photoDocumentId,
      staleTime: 60_000,
    },
  });
  const saved = profile?.saved ?? {};
  const documentId =
    client.photoDocumentId ||
    String(
      saved.profile_image_document_id ||
        saved.entity_logo_document_id ||
        saved.photo_document_id ||
        '',
    ) ||
    profile?.photoDocumentId;
  const sourceId = String(saved.profile_image_client_id || client.id);
  const photoUrl = useClientPhoto(sourceId, documentId);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const parts = client.displayName.trim().split(/\s+/).filter(Boolean);
  const initials =
    parts.length === 0
      ? '?'
      : (
          parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')
        ).toUpperCase();

  return (
    <div
      aria-hidden="true"
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden text-[12px] font-semibold',
        shape === 'square' ? 'rounded-none' : 'rounded-full',
        client.status.toUpperCase() === 'PROSPECT'
          ? 'bg-muted text-muted-foreground'
          : 'bg-primary/10 text-primary',
      )}
    >
      {photoUrl && photoUrl !== failedUrl ? (
        <img
          src={photoUrl}
          alt=""
          className={cn(
            'h-full w-full',
            client.clientType === 'CORPORATE' || client.clientType === 'TRUST'
              ? 'object-contain'
              : 'object-cover',
          )}
          onError={() => setFailedUrl(photoUrl)}
        />
      ) : (
        initials
      )}
    </div>
  );
}
